/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-01 11:12:22
 */
import ColumnTypes from '@/utils/ColumnTypes';

function getColums(that) {
	//抖音
	let lastMonthSales = {
		key: 'sales',
		label: '30天销量',
		type: ColumnTypes.TextCell,
		minWidth: '100',
		isShow: that.$isDy(that.platformId),
	}
	//快手
	let sales = {
		key: 'sales',
		label: '30天销量',
		type: ColumnTypes.TextCell,
		minWidth: '100',
		isShow: that.$isKs(that.platformId),
	}

	let arr = [
		{
			key: 'shopDetails',
			label: '商品信息',
			type: ColumnTypes.MixinCell,
			showProductType: true,
			fixed: 'left',
			minWidth: '300',
			isShow: true,
			commissionType: true,
		},
		{
			key: 'contact_user_type_text',
			label: '推广者信息',
			type: ColumnTypes.TextCell,
			minWidth: '130',
			isShow: that.$isKs(that.platformId)
		},
		{
			key: 'sale_price',
			label: '现售价',
			type: ColumnTypes.TextCell,
			minWidth: '100',
			isShow: true,
		},
		{
			key: 'live_price',
			label: '直播价',
			type: ColumnTypes.TextCell,
			minWidth: '100',
			isShow: true,
		},
		{
			key: 'commission_rate',
			label: '佣金率',
			type: ColumnTypes.TextCell,
			minWidth: '100',
			isShow: true,
		},
		{
			key: 'service_rate',
			label: '服务费率',
			isShow: that.$auth.hasPermi('system:goods-ServiceRate'),
			type: ColumnTypes.serviceRateCell,
			minWidth: '100',
		},
		lastMonthSales,
		sales,
		{
			key: 'sample_rule',
			label: '样品规则',
			isShow: true,
			type: () => import('@/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue'),
			minWidth: '200',
		},
		{
			key: 'partner_rate',
			label: '提成比',
			isShow: that.isDrPartnerDataView && that.vuex_userInfo?.rate_status,
			type: ColumnTypes.serviceRateCell,
			minWidth: '100',
			helpNum: 1,
			helpDesc1: '订单金额*提成比为未扣除抖音技术服务费时可得提成，实际可得提成需扣除技术服务费',
		},
		{
			key: 'promote_info',
			label: '推广信息',
			type: ColumnTypes.promotionCell,
			isShow: true,
			minWidth: '160',
		},
		{
			key: 'partner_name',
			label: '招商运营',
			type: ColumnTypes.TextCell,
			isShow: true,
			minWidth: '100',
		},
		{
			key: 'activity',
			label: '活动信息',
			type: ColumnTypes.activityCell,
			minWidth: '270',
			isShow: true,
		},
		{
			key: 'remark',
			label: '备注',
			type: ColumnTypes.TextCell,
			minWidth: '100',
			isShow: true,
		},
		{
			key: 'operations',
			label: '操作',
			type: ColumnTypes.ButtonsCell,
			minWidth: '100',
			fixed: 'right',
			align: 'right',
			isShow: true,
		},
	];
	return arr;
}
export default getColums;
